<template>
  <div class="modal sign-modal">
    <div class="overlay" @click="$parent.closeSignIn" />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <button class="close" @click="$parent.closeSignIn">
              <div class="desc smallest">{{ $t("Close") }}</div>
              <img class="img" src="./../img/close.svg" />
            </button>

            <a
              class="modal-back"
              @click="switchToLogin"
              v-if="!loginContentVisible"
            >
              <img class="modal-back-img" src="./../img/back.svg" />
              <div class="desc smallest">{{ $t("Back") }}</div>
            </a>
            <div class="left">
              <div class="top-text">
                <div class="title big title-main">{{ $t("Sign In") }}</div>
              </div>
              <div class="bottom-text">
                <div class="title">{{ $t("Don't have an account?") }}</div>
                <a class="button bordered" @click="$parent.openSignUp">
                  <span> {{ $t("Sign up") }} </span>
                </a>

                <img class="traveler" src="./../img/traveler.webp" />
              </div>
            </div>
            <div class="right">
              <div
                :class="[
                  'form-fields login-content',
                  { hidden: !loginContentVisible },
                ]"
              >
                <div class="form-fields-wrapper">
                  <label>
                    <div class="desc">{{ $t("E-mail") }}</div>
                    <input
                      v-model="email"
                      type="email"
                      :placeholder="$t('Email')"
                    />
                  </label>
                  <label>
                    <div class="desc">{{ $t("Password") }}</div>
                    <input
                      v-model="pass"
                      type="password"
                      :placeholder="$t('Password')"
                    />
                  </label>
                  <div class="cta-container">
                    <button class="button blue small" @click="submitLogin">
                      <span> {{ $t("LOGIN") }} </span>
                    </button>
                  </div>
                  <transition name="slide">
                    <div v-if="$parent.error" class="error-desc desc red">
                      {{ $parent.error }}
                    </div>
                  </transition>
                </div>
                <div class="modal-bottom">
                  <a class="desc orange" @click="switchToforgotPass">
                    {{ $t("Forgot password?") }}
                  </a>
                </div>
              </div>
              <div
                :class="[
                  'form-fields forgot-pass-content',
                  { hidden: !forgotPassContentVisible },
                ]"
              >
                <div class="form-fields-wrapper">
                  <div class="title big title-main">
                    {{ $t("Forgot password?") }}
                  </div>
                  <label>
                    <div class="desc">{{ $t("E-mail") }}:</div>
                    <input
                      v-model="email"
                      type="email"
                      :placeholder="$t('Email')"
                    />
                  </label>
                  <div class="cta-container">
                    <button class="button blue small" @click="submitForgotPass">
                      <span> {{ $t("Recover") }} </span>
                    </button>
                  </div>
                  <transition name="fade">
                    <div v-if="$parent.successMessage" class="desc green">
                      {{ $parent.successMessage }}
                    </div>
                  </transition>
                  <transition name="slide">
                    <div v-if="$parent.error" class="error-desc desc red">
                      {{ $parent.error }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  props: [],
  data: function () {
    return {
      loginContentVisible: true,
      forgotPassContentVisible: false,
      email: "",
      pass: "",
    };
  },
  mounted() {},
  methods: {
    switchToforgotPass() {
      this.$parent.clearError();
      setTimeout(() => {
        this.loginContentVisible = false;
        this.forgotPassContentVisible = true;
      }, 100);
    },
    switchToLogin() {
      this.$parent.clearError();
      setTimeout(() => {
        this.forgotPassContentVisible = false;
        this.loginContentVisible = true;
      }, 100);
    },
    submitLogin() {
      let loginData = {
        username: this.email,
        password: this.pass,
      };
      this.$emit("login", loginData);
    },
    submitForgotPass() {
      let data = {
        email: this.email,
      };
      this.$emit("forgotPass", data);
    },
  },
};
</script>
